// ************************************************** //
// INTERSECTION OBSERVER PIXEL
// ************************************************** //

const iop = new IntersectionObserver((entries) => {
	const header = document.getElementById("header");
	if (entries[0].isIntersecting) {
		// docked nav, transparent background
		if (header.classList.contains("sticky")) {
			header.classList.remove("sticky");
		}
	} else {
		// sticky nav, opaque background
		if (!header.classList.contains("sticky")) {
			header.classList.add("sticky");
		}
	}
});

iop.observe(document.getElementById("iop"));
